import { useEffect, useState } from "react";
import TermContent from "src/components/seller/Terms/TermContent";
import TermContentEn from "src/components/seller/Terms/TermContentEn";

const Terms = ({ userData, hideHeader = false }) => {
  const [contactPercent, setContactPercent] = useState({
    desc: "10%",
    fee: "10%",
    feeCard: "3%",
  });

  const showEnglishTermsEmails = [
    "kloy@woodmark.com.sg",
    // "develop_charinrat.b+2@xsurface.com",
  ];

  const contract_percent_desc = (email = "") => {
    let percent;

    switch (email) {
      case "viwatchaiflooring@gmail.com":
        percent = "10%";
        break;
      case "chutidech@future-tech.co.th":
        percent = "25%";
        break;
      case "mkt.hdp@gmail.com":
        percent = "%";
        break;
      case "deccodecorative@gmail.com":
        percent = "20%";
        break;
      case "sksdecor@gmail.com":
        percent = "10%";
        break;
      case "pichapa.ow@remood.co.th":
        percent = "20%";
        break;
      default:
        percent = "10%";
    }
    return percent;
  };

  const contract_percent_fee = (email = "") => {
    let percent;

    switch (email) {
      case "viwatchaiflooring@gmail.com":
        percent = "10%";
        break;
      case "chutidech@future-tech.co.th":
        percent = "25%";
        break;
      case "mkt.hdp@gmail.com":
        percent = `พรม 15% \n
          ฟิล์ม 20% \n
          หินสังเคราะห์ 13% \n
          หินควอท์ 15% \n
          เฟรมอลูมิเนียม 15% \n
          ชุดครัว 15%\n`;
        break;
      case "deccodecorative@gmail.com":
        percent = "20%";
        break;
      case "sksdecor@gmail.com":
        percent = "10%";
        break;
      case "pichapa.ow@remood.co.th":
        percent = "20%";
        break;
      default:
        percent = "10%";
    }
    return percent;
  };

  const contract_percent_fee_card = (email = "") => {
    let percent;

    switch (email) {
      case "viwatchaiflooring@gmail.com":
        percent = "3.5%";
        break;
      case "chutidech@future-tech.co.th":
        percent = "3.5%";
        break;
      case "mkt.hdp@gmail.com":
        percent = `3.5%`;
        break;
      case "deccodecorative@gmail.com":
        percent = "3.5%";
        break;
      case "sksdecor@gmail.com":
        percent = "3%";
        break;
      case "pichapa.ow@remood.co.th":
        percent = "3.5% ";
        break;
      default:
        percent = "3%";
    }
    return percent;
  };

  useEffect(() => {
    if (!userData?.email) return;
    let formatEmail = userData?.email?.toLowerCase();
    setContactPercent({
      desc: contract_percent_desc(formatEmail),
      fee: contract_percent_fee(formatEmail),
      feeCard: contract_percent_fee_card(formatEmail),
    });
  }, [userData.email]);

  return (
    <>
      {showEnglishTermsEmails.includes(userData?.email) ? (
        <TermContentEn
          contactPercent={contactPercent}
          userData={userData}
          hideHeader={hideHeader}
        />
      ) : (
        <TermContent
          contactPercent={contactPercent}
          userData={userData}
          hideHeader={hideHeader}
        />
      )}
    </>
  );
};

export default Terms;
